<template>
  <div class="help">
		<div class="action_bar"></div>
		<main>
			<h1>Help</h1>
			<button class="chat" @click="launchIntercom()">
				<div>
					Chat with an agent
					<p>Online Mon-Fri, 9am-6pm</p>
				</div>
				<div class="indicator--new"></div>
			</button>

			<div class="app_guides">
				<div class="title_block">
					<h5>App guides</h5>
					<button class="more">Show all</button>
				</div>
				<ul>
					<li>
						<button class="list_item video_item">
							<div class="video"></div>
							<div class="video_title">How to create a template</div>
						</button>
					</li>
					<li>
						<button class="list_item video_item">
							<div class="video"></div>
							<div class="video_title">Using LabelSnaps</div>
						</button>
					</li>
					<li>
						<button class="list_item video_item">
							<div class="video"></div>
							<div class="video_title">Using LabelSnaps</div>
						</button>
					</li>
					<li>
						<button class="list_item video_item">
							<div class="video"></div>
							<div class="video_title">Using LabelSnaps</div>
						</button>
					</li>
				</ul>
			</div>

			<div class="help--guides">
				<div class="title_block">
					<h5>MSP guides</h5>
					
				</div>
				<ul>
					<li><button class="list_item">Billing code directory</button></li>
					<li><button class="list_item">Speciality billing guides</button></li>
					<li><button class="list_item">Submission deadlines</button></li>
					<li><button class="list_item">Explanatory codes</button></li>
				</ul>
			</div>

			<div class="help--guides">
				<div class="title_block">
					<h5>Articles</h5>
					<button class="more">Show all</button>
				</div>
				<ul>
					<li><button class="list_item">5 reasons why MSP claims get delayed</button></li>
					<li><button class="list_item">How to avoid over-age MSP claims</button></li>
					<li><button class="list_item">Telehealth codes for MSP billing</button></li>
				</ul>
			</div>
    </main>
  </div>
</template>


<script>
export default {
	methods: {
		launchIntercom() {
			alert('Launch intercom chat');
		},
	}
}
</script>


<style scoped>
.help {
	-webkit-overflow-scrolling: touch;
	bottom: calc(3rem + env(safe-area-inset-bottom));
	left: 0;
	overflow-y: scroll;
	overflow-x: hidden;
	position: fixed;
	right: 0;
	top: env(safe-area-inset-top);
}
main {
	padding: 0 1rem 1rem;
}
h1 {
	font-weight: 700;
	margin-bottom: 1.5rem;
}
h5 {
	color: #333;
	font-size: 22px;
	font-weight: 600;
}
li button {
	color: #777;
	font-size: 17px;
	font-weight: 500;
}

.title_block {
	align-items: baseline;
	border-bottom: 1px solid #ccc;
	display: flex;
	justify-content: space-between;
	margin-bottom: 0.25rem;
	padding-bottom: 0.5rem;
}
button.more {
	color: var(--blue);
	font-size: 13px;
	font-weight: 600;
	text-transform: uppercase;
}


button.chat {
	align-items: center;
	/*background-color: rgba(0,0,0,0.06);*/
	background-color: var(--light-blue);
	border-radius: 10px;
	display: flex;
	font-size: 23px;
	font-weight: 700;
	justify-content: space-between;
	padding: 1rem;
	text-align: left;
	width: 100%;
}
button.chat p {
	color: #888;
	font-size: 15px;
	font-weight: 500;
	line-height: 1em;
	margin-top: 0.375rem;
}

.indicator--new {
	background-color: var(--blue);
	border-radius: 7px;
	height: 14px;
	width: 14px;
}

.help--guides {
	margin-top: 2rem;
}
.help--guides ul {
	border: none;
}
.help--guides li {
	border: none;
}
.help--guides li button {
	background: url('/img/icon--chevron--right.svg') no-repeat right center;
	height: 48px;
	text-align: left;
	width: 100%;
}


.app_guides {
	margin-top: 2rem;
}
.app_guides ul {
	border: none;
	display: flex;
	justify-content: flex-start;
	margin-left: -1rem;
	margin-top: 0.5rem;
	overflow-x: scroll;
	padding-left: 1rem;
	width: calc(100% + 2rem);
}
.app_guides ul::-webkit-scrollbar {
	display: none;
}
.app_guides li {
	border: none;
	width: 200px;
}
.app_guides li + li {
	margin-left: 1rem;
}

.help--guides li button.video_item {
	align-items: center;
	display: flex;
	flex-direction: column;
	height: auto;
	/*padding-bottom: 0.25rem;
	padding-top: 0.25rem;*/
}
.video {
	background-color: #eee;
	border-radius: 8px;
	display: inline-block;
	height: 120px;
	margin-bottom: 0.5rem;
	margin-right: 0.5rem;
	width: 200px;
}
.video_title {
	font-size: 16px;
	line-height: 22px;
	text-align: left;
}
</style>
